export const communicationActionStyle = {
  fontFamily: "Source Sans Pro !important",
  fontWeight: "400 !important",
  fontSize: "13px !important",
  lineHeight: "16px !important",
  letterSpacing: "0.4px !important",
  color: "black !important",
  fontStyle: "italic !important",
  marginTop: 0,
  marginBottom: 1,
};
